export default "__VITE_ASSET__CSwD0lHY__"